import { render, staticRenderFns } from "./HuaxianCooperationList.vue?vue&type=template&id=99a9ae86&scoped=true&"
import script from "./HuaxianCooperationList.vue?vue&type=script&lang=js&"
export * from "./HuaxianCooperationList.vue?vue&type=script&lang=js&"
import style0 from "./HuaxianCooperationList.vue?vue&type=style&index=0&id=99a9ae86&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99a9ae86",
  null
  
)

export default component.exports